import { BrowserRouter as Router, Route } from "react-router-dom"
import { Store } from "./providers"
import Main from "./Pages/Main"

export default function Routes() {
  return (
    <Store>
      <Router>
        <Route exact path="/" component={Main} />
        <Route path="/main" component={Main} />
      </Router>
    </Store>
  )
}
